<template>
    <div class="container drawing-map-box" :class="fullScreen? `drawing-map-box-active`:``" >
        <div class="map-box" id="container"></div>
        
        <!-- 标题 -->
        <!-- <div  v-if="isOk" class="big-title" :class="fullScreen? `big-title-active`:``">{{bigTitle}}</div> -->
        
        <!-- 切换楼层 -->
        <!-- <i  v-if="isOk" class="iconhebei iconlouceng icon-switch" :class="fullScreen? `icon-switch-active`:``"></i> -->

        <div v-if="isOk" class="floor-box" :class="fullScreen? `floor-box-active`:``">
            <div class="iconhebei iconlouceng inner-icon-switch g-b-500" v-touch:tap="onChangeFloorFlag"></div>
            <ul class="inner-box" :class="floorFlag? ``:`inner-box-active`">
                <li 
                    v-for="(item, index) in floorList" :key="index"
                    class="floo-item"
                    v-touch:tap="onChangeFloorNumber(index+1)"
                >{{item}}</li>
            </ul>
        </div>

        <i  v-if="isOk" class="iconhebei lang-icon screen-icon" :class="fullScreen? `icontuichuquanping`:`iconquanping`" v-touch:tap="setScreen"></i>

        <ul v-if="isOk" class="util-box" :class="fullScreen? `util-box-active`:``">
            <li class="util-item f-c " v-touch:tap="onChangeItem('up')">
                <i 
                    :class="menuActive === 0 ? '':'util-item-active'"
                    class="iconfont iconjiantouarrow487 up"></i>
            </li>

            <ul class="inner-box">

                <li 
                    v-for="(item, index) in menuList" :key="index"
                    class="util-item"
                    :data-index="index"
                    :class="item.active === menuActive ? `util-item-active util-box-active-box`:``"
                    v-touch:tap="onChangeMenuActive(index)"
                >
                    <div>
                        <i 
                            class="iconhebei" 
                            :class="item.active === menuActive ? `${item.icon} util-item-active ${item.activeClass}`:`${item.icon}`"
                            ></i>
                    </div>
                    <div>
                        <span>{{item.name}}</span>
                    </div>
                </li>

            </ul>
            


            <li class="util-item f-c" v-touch:tap="onChangeItem('below')">
                <i 
                    :class="menuActive === (menuList.length-1) ? '':'util-item-active'"
                    class="iconfont iconjiantouarrow487 below"></i>
            </li>
        </ul>

        <van-popup
            class="popup-box"
            v-model="show"
            round
            position="bottom"
            closeable
            :style="{ minHeight: '45%' }"
        >

            <div class="title">{{detailObj.name}}</div>
            <div v-if="detailObj.comment">
                <div v-html="detailObj.comment"></div>
            </div>
            <div v-else>暂无介绍</div>

        </van-popup>

        <van-popup
            class="popup-box introduce-box"
            v-model="introduceShow"
            round
            position="bottom"
            closeable
            :style="{ minHeight: '45%', height:'90%' }"
        >

            <!-- <div class="title">{{introduceObj.title}}</div> -->
            <!-- <van-image 
                class="image"
                lazy-load
                :src="introduceObj.image"
            /> -->
            <div v-if="introduceObj.desc" class="inner-content-box">
                <div v-html="introduceObj.desc"></div>
            </div>
            <div v-else>暂无介绍</div>

        </van-popup>
    
    </div>

</template>

<script>
    import http from '@js/http-zyz.js';
    import {
        getMaprelicListUrl,
        getMaprelicInfoUrl,
    } from '@drawingMapUrl';
    import {
        groundFloor,
        secondFloor,
        thirdFloor,
    } from './drawingMapData';
    import {
        getAllNewsdetailsUrl
    } from '@culturalRelicsUrl';
    import { Popup } from 'vant';
    export default {
        data() {
            return {
                imageList: [
                    require('@image/home/map-0.png'),
                    require('@image/home/map-1.png'),
                    require('@image/home/map-2.png'),
                    require('@image/home/map-3.png'),
                ],
                secondFloor: 1,
                fullScreen: false,
                isOk: false,
                menuActive: 0,
                menuList: [],
                markerList:[],
                boothMarkerList: [],//  展台工具类maker存放处
                boothList:[],
                show: false,
                introduceShow: false,
                map: {},
                lang: "zh_cn", //可选值：en，zh_en, zh_cn,
                list:[],
                floorList: ['1F', '2F', '3F'],
                floorFlag: false,
                detailObj: {
                    id:''
                },
                exhibitionHallNumber:'',//..展厅号码
                // bigTitle: '',
                introduceObj:{
                    image: '',
                    title: '',
                    desc: '',
                },
                angle: 0, //    地图初始旋转角度
                tempToast: null,
            }
        },
        created() {
            var {
                floor = 1
            } = this.$route.query;
            this.init(Number(floor));
        },  
        mounted() {
            this.createMap();
        },
        methods: {
            init(key = 1){
                this.tempToast = this.$toast.loading({
                    duration: 0,
                    message: '加载中...',
                    forbidClick: true,
                    overlay: true,
                });
                this.angle = 0;
                switch (key) {
                    case 1:
                        this.menuList = groundFloor.list;
                        this.boothList = groundFloor.boothList;
                        // this.bigTitle = '一层平面布局图';
                        document.title = '一层平面布局图';
                        break;
                    case 2:
                        this.menuList = secondFloor.list;
                        this.boothList = secondFloor.boothList;
                        // this.bigTitle = '二层平面布局图';
                        document.title = '二层平面布局图';
                        break;
                    case 3:
                        this.menuList = thirdFloor.list;
                        this.boothList = thirdFloor.boothList;
                        // this.bigTitle = '三层平面布局图';
                        document.title = '三层平面布局图';
                        break;
                    default:
                        break;
                }
                this.secondFloor = key;
            },
            createMap(){
                window.onLoad  = ()=> {
                    this.map = new AMap.Map('container', {
                        resizeEnable: true,
                        zoom:18,//级别
                        center: [110.379051,20.015266],
                        lang: this.lang,
                        showIndoorMap: true, 
                        pitchEnable:false,
                        pitch: 25,
                        viewMode: "2D", 
                        showLabel: false, //不显示地图文字标记
                        // zoomEnable:false,
                        // 在PC上，取值范围为[3-18]；在移动设备上，取值范围为[3-19]
                        zooms:[18,19],
                        // dragEnable: false,
                        rotateEnable: true,
                        features: ['road', 'building'],// 'bg'（地图背景）、'point'（POI点）、'road'（道路）、'building'（建筑物）
                        layers: [
                            new AMap.TileLayer(),
                            this.setImage()
                        ]
                    });


                    this.map.on("complete", ()=>{
                        // this.map.setRotation(180)
                        // this.map.setRotation(-135)

                        //  展示隐藏的内容
                        this.isOk = true;
                        this.tempToast.clear();

                        //  获取文物信息  
                        this.getMaprelicList();

                        //  设置工具类marker
                        this.setMarkerInit();

                        //  设置展台marker
                        this.setBoothMarker();

                        //  限定拖动位置
                        var bounds = this.map.getBounds();
                        this.map.setLimitBounds(bounds);

                        //  指北针和缩放按钮
                        AMap.plugin([
                            'AMap.ToolBar',
                            'AMap.ControlBar',
                        ],()=>{
                            // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
                            this.map.addControl(new AMap.ToolBar({
                                // 简易缩放模式，默认为 false
                                liteStyle: true,
                                position: 'LB',
                            }));
                            this.map.addControl(new AMap.ControlBar());
                        });

                        // //  给自己点经纬度的时候使用
                        // this.map.on('click', function(e) {
                        //     console.log(
                        //         e.lnglat.getLng() + ',' + e.lnglat.getLat()
                        //     )
                        // });

                    });

                    //  地图manker旋转
                    this.map.on("moveend", ()=>{
                        this.angle = -this.map.getRotation();
                        this.markerList.forEach(item=>{
                            item.setAngle(this.angle);
                        })
                        this.boothMarkerList.forEach(item=>{
                            item.setAngle(this.angle);
                        })
                    })

                    // //实时路况图层
                    // var trafficLayer = new AMap.TileLayer.Traffic({
                    //     zIndex: 10
                    // });
                    // trafficLayer.setMap(this.map);

                    // this.setMarker();

                }
                var url = 'https://webapi.amap.com/maps?v=1.4.15&key=e44886128917773ba756db5651a65261&callback=onLoad';
                var jsapi = document.createElement('script');
                jsapi.charset = 'utf-8';
                jsapi.src = url;
                document.head.appendChild(jsapi);
            },
            setLang(){
                if(this.lang === 'zh_cn'){
                    this.lang = 'en';
                }else{
                    this.lang = 'zh_cn';
                }
                this.map.setLang(this.lang);
            },
            setScreen(){
                this.fullScreen = !this.fullScreen;
                if(this.fullScreen === false){
                    this.floorFlag = false;
                }
            },
            onChangeFloorFlag(){
                this.floorFlag = !this.floorFlag;
            },
            onChangeFloorNumber(index){
                return ()=>{
                    if(this.secondFloor === index) return
                    this.floorFlag = false;
                    this.menuActive = 0;
                    this.isOk = false;
                    this.map.destroy();
                    this.init(index);
                    this.createMap();
                }
            },
            setImage(){
                var imageLayer = new AMap.ImageLayer({
                    // url: 'http://amappc.cn-hangzhou.oss-pub.aliyun-inc.com/lbs/static/img/dongwuyuan.jpg',
                    url: this.imageList[this.secondFloor],
                    zIndex: 12,
                    bounds: new AMap.Bounds(
                        [110.378171,20.014212],
                        // [110.379973,20.016283],
                        // [110.379925,20.016241],
                        [110.379925,20.016251],
                    ),
                    zooms: [15, 19]
                });
                return imageLayer;
            },
            // 文物marker
            setMarker(){
                var tempArray = [];
                this.list.map(item=>{
                    let position = new AMap.LngLat(item.latitude, item.longitude);
                    let markerContent = `` +
                        `<div class="marker-box marker-box-t">` +
                        `   <i class="iconfont iconwenwuziyuan icon-size"></i>` +
                        `   <span class="txt">${item.name}</span>` +
                        `</div>`;
                    let marker = new AMap.Marker({
                        position: position,
                        content: markerContent,
                        angle: this.angle,
                        autoRotation: true,
                        animation: "AMAP_ANIMATION_BOUNCE",
                        offset: new AMap.Pixel(0, 0)
                    });
                    // marker.rawData =  item;
                    marker.on('click', ()=>{
                        var {
                            id
                        } = item;
                        if(id !== this.detailObj.id) {
                            this.getMaprelicInfo(id);
                        }else{
                            this.onChange();
                            event.preventDefault();
                        }
                    });
                    tempArray.push(marker);
                })
                this.map.add(tempArray);
                // this.map.remove(marker);
            },
            onChange(){
                this.show = !this.show;
            },
            onChangeIntroduceShow(){
                this.introduceShow = !this.introduceShow;
            },
            getMaprelicList() {
                http.get(getMaprelicListUrl, {params:{
                    floor: this.secondFloor,
                }})
                .then(res=>{
                    var {
                        data: {
                            data: array = []
                        }
                    } = res;
                    // array[0].latitude = '110.378251';
                    // array[0].longitude = '20.014333';
                    // array[1].latitude = '110.3794';
                    // array[1].longitude = '20.015734';
                    if(array.length>0){
                        this.list = array;
                        this.setMarker();
                    }
                })
            },
            getMaprelicInfo(id) {
                http.get(getMaprelicInfoUrl, {params:{id}})
                .then(res=>{
                    var {
                        data = null
                    } = res.data;
                    if(data) this.detailObj = data;
                    this.onChange();
                })
            },
            onChangeMenuActive(index){
                return ()=>{ 
                    if(this.menuActive === index) return
                    this.menuActive = index;
                    window.document.getElementsByClassName('util-item')[this.menuActive].scrollIntoView()
                    this.setMarkerInit();
                }
            },
            onChangeItem(type = 'middle'){
                return ()=>{
                    let head = 0,
                        end = this.menuList.length - 0;
                    if(type === 'up'){
                        if(this.menuActive-1 >= head) {
                            this.menuActive--;
                            this.setMarkerInit();
                        }
                    }else if(type === 'below'){
                        if(this.menuActive+1 < end) {
                            this.menuActive++;
                            this.setMarkerInit();
                        }
                    }
                    // window.document.querySelector(`.inner-box .${this.menuList[this.menuActive].icon}`).scrollIntoView()
                    window.document.getElementsByClassName('util-item')[this.menuActive].scrollIntoView()


                    // this.setMarkerInit();
                    //  分别写两在两个页面里面 为了不在头顶和尾部的时候还会闪烁
                }
            },
            //  工具类Marker
            setMarkerInit(){
                var {
                    name = '',
                    activeClass = '',
                    icon = '',
                    list = [],
                } = this.menuList[this.menuActive];
                this.map.remove(this.markerList);
                this.markerList = [];
                list.map(item=>{
                    var position = new AMap.LngLat(item[0], item[1]);
                    var markerContent = `` +
                        `<div class="marker-box marker-box-t">` +
                        `   <i class="iconhebei icon-marker ${icon} ${activeClass}"></i>` +
                        // `   <span class="txt">${name}</span>` +
                        `</div>`;
                    var marker = new AMap.Marker({
                        position: position,
                        angle: this.angle,
                        content: markerContent,
                        offset: new AMap.Pixel(0, 0)
                    });
                    this.markerList.push(marker);
                })
                this.map.add(this.markerList);
            },
            setBoothMarker(){
                var tempArray = [];
                this.boothList.map(item=>{
                    let position = new AMap.LngLat(item.position[0], item.position[1]);
                    let markerIcon = ``;
                    if(item.icon){
                        markerIcon = `   <i class="iconhebei icon-size ${item.icon} ${item.activeClass}"></i>`;
                    }else{
                        markerIcon = `   <i class="iconhebei iconcancel-mark-red icon-size"></i>`;
                    }
                    let markerContent = `` +
                        `<div class="marker-box marker-box-t">` +
                            markerIcon+
                        `   <span class="txt">${item.name}</span>` +
                        `</div>`;
                    let marker = new AMap.Marker({
                        position: position,
                        content: markerContent,
                        angle: this.angle,
                        offset: new AMap.Pixel(0, 0)
                    });
                    // marker.rawData =  item;
                    marker.on('click', ()=>{
                        var {
                            id = ''
                        } = item;
                        if(id === '') return;
                        if(id !== this.exhibitionHallNumber) {
                            this.exhibitionHallNumber = id;
                            this.getDetailInfo(id);
                        }else{
                            this.onChangeIntroduceShow();
                            event.preventDefault();
                        }
                    });
                    tempArray.push(marker);
                })
                this.boothMarkerList = tempArray;
                this.map.add(tempArray);
                // this.map.remove(marker);
            },
            //获取新闻详情
            getDetailInfo(id){
                http.get(getAllNewsdetailsUrl, { params:{id}}) 
                .then(res=>{
                    var {
                        data: {
                            data
                        }
                    } = res.data;
                    this.introduceObj.image = data.smallImage;
                    this.introduceObj.title = data.title;
                    this.introduceObj.desc = data.text;
                    this.introduceObj.rawData = data;
                    // console.log(data)
                    this.onChangeIntroduceShow();
                })
            },
        },      
        components:{
            [Popup.name]: Popup,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        position: relative;
        .map-box{
            height: 100%;
            box-sizing: border-box;
        }
        .big-title{
            position: fixed;
            top: 12px;
            left: 50%;
            transform: translateX(-50%);
            font-weight: 500;
            font-size: 18px;
            color: #4b4846;
            transition: all .3s ease;
            text-shadow:#ffffff 1px 0 0,#ffffff 0 1px 0,#ffffff -1px 0 0,#ffffff 0 -1px 0;
            -webkit-text-shadow:#ffffff 1px 0 0,#ffffff 0 1px 0,#ffffff -1px 0 0,#ffffff 0 -1px 0;
            -moz-text-shadow:#ffffff 1px 0 0,#ffffff 0 1px 0,#ffffff -1px 0 0,#ffffff 0 -1px 0;
            filter: Glow(color=#ffffff, strength=1);
        }
        .big-title-active{
            top: -50px;
        }
        .icon-switch{
            position: fixed;
            left: 10px;
            top: 50px;
            padding: 3px;
            transition: all .3s ease;
            background-color: rgba(255,255,255,0.9);
            box-shadow: 1px 1px 10px 0 #ccc;
            border-radius: 3px;
            z-index: 5;
            &::before{
                font-size: 20px;
            }
        }
        .icon-switch-active{
            left: -50px;
        }
        .floor-box{
            position: fixed;
            left: 10px;
            top: 50px;
            transition: all .3s ease;
            .inner-icon-switch{
                border-radius: 3px;
                padding: 3px;
                background-color: rgba(255,255,255,0.9);
                box-shadow: 1px 1px 10px 0 #ccc;
                margin-bottom: 5px;
                &::before{
                    font-size: 20px;
                }
            }
            .inner-box{
                height: 96px;
                box-sizing: border-box;
                transition: all .3s ease;
                overflow: hidden;
                .floo-item{
                    text-align: center;
                    border-radius: 3px;
                    padding: 3px;
                    box-shadow: 1px 1px 10px 0 #ccc;
                    margin-bottom: 5px;
                    background-color: rgba(255,255,255,0.9);
                    &:last-of-type{
                        margin: 0;
                    }
                }
            }
            .inner-box-active{
                height: 0;
                background-color: rgba(255,255,255,0.9);
            }
        }
        .floor-box-active{
            left: -50px;
        }
        .lang-icon{
            position: absolute;
            left: 10px;
            top: 10px;
            &::before{
                font-size: 20px;
            }
        }
        .screen-icon{
            padding: 3px;
            transition: all .3s ease;
            background-color: rgba(255,255,255,0.9);
            box-shadow: 1px 1px 10px 0 #ccc;
            border-radius: 3px;
        }
        .popup-box{
            box-sizing: border-box;
            padding: 40px 10px;
            .title{
                text-align: center;
                margin-bottom: 10px;
            }
        }
        .introduce-box{
            padding-bottom: 0;
            .inner-content-box{
                height: 100%;
                overflow-y: scroll;
                overflow-x: hidden;
            }
            .image{
                width: 100%;
                min-height: 200px;
            }
        }
        .util-box{
            box-sizing: border-box;
            transition: all .3s ease;
            background-color: rgba(255,255,255,0.9);
            width: 45px;
            position: fixed;
            right: 10px;
            font-size: 10px;
            bottom: 10px;
            border-radius: 3px;
            box-shadow: 1px 1px 10px 0 #ccc;
            color:rgba(210, 206, 206, 0.5);
            .inner-box{
                height: 150px;
                overflow-y: scroll;
                transition: all .3s ease;
                &::-webkit-scrollbar {display:none}
            }
            .util-item{
                display: flex;
                align-content: center;
                justify-content: center;
                flex-direction: column;
                transition: all .3s ease;
                padding: 5px;
                font-weight: 500;
                min-height: 45px;
                background-color: rgb(254, 254, 253);
                border-bottom: 1px solid rgba(210, 206, 206, 0.5);
                text-align: center;
                letter-spacing: -2px;
                color: #04281d;
                &:last-of-type{
                    border: 0;
                }
                .up{
                    display: block;
                    transform: rotate(-90deg);
                }
                .below{
                    display: block;
                    transform: rotate(90deg);
                }
            }
            .f-c{
                margin: 0;
                border: 0;
                padding: 0;
            }
            .util-item-active{
                // color: #666;
                // border: 1px solid #038ad5;
            }
            .util-box-active-box{
                // border: 1px solid #038ad5;
                // border-radius: 3px;
                background-color: rgb(231,248,247);
            }
            .car-active{
                color: #038ad5;
            }
            .iconyiersanjiyoukezhongxin{
                &::before{
                    font-size: 25px;
                }
            }
            .iconyiliao06{
                &::before{
                    font-size: 20px;
                }
            }
            .iconyiersanjiyoukezhongxin-active{
                color: #f03644;
            }
            .icondianti-active{
                color: #063b37;
            }
            .iconyiliao06-active{
                color: #2634bd;
            }
            .iconjiuzhibao-active{
                color: green;
            }
            .iconwuzhangai-active{
                color: #063b37;
                width: 22px;
                overflow: hidden;
                display: inline-block;
            }
            .iconwuzhangai{
                width: 22px;
                overflow: hidden;
                display: inline-block;
            }
        }
        .util-box-active{
            right: -50px;
        }
    }

</style>